/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_FootnoteInputs */



/**
* | output |
* | --- |
* | "Your practice conversations are private: nobody else sees them." |
*
* @param {Onboarding_Pilot_How_FootnoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_footnote = /** @type {((inputs?: Onboarding_Pilot_How_FootnoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_FootnoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je oefengesprekken zijn privé: niemand anders ziet ze.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos entretiens d’entraînement sont privés : personne d’autre ne les voit.")
	return /** @type {LocalizedString} */ ("Your practice conversations are private: nobody else sees them.")
});